<template>
  <c-base-dialog
    v-model="isShow"
    :option="option"
    @close="$emit('close')"
  >
    <template slot="body">
      <div class="reward">
        <div class="title">当前角色</div>
        <div class="reward-body">
          <div class="reward-role">
            <div>{{ partitionName }}</div>
            <!-- <div>xx大区</div> -->
            --
            <div>{{ roleName }}</div>
            <!-- <div>西欧昂</div> -->
          </div>
          <div class="reward-change-bind" @click="changeBindHandler">
            <a>选择其他角色</a>
          </div>
        </div>
      </div>
    </template>
    <template slot="fotter">
      <div class="fotter-button">
        <div class="confirm" @click="confirmHandler">
          确认
        </div>
      </div>
    </template>

  </c-base-dialog>
</template>

<script>
import CDialog from '../base-dialog';
import common from '../../common';
import gameRoleSelect from './index';
export default {
  name: 'ConfirmGameRole',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    gameCode: String,
    roleInfoObj: Object,
    option: Object,
  },
  data() {
    return {
      isShow: true,
    };
  },
  computed: {
    partitionName() {
      return common.tool.Base64.decode(this.roleInfoObj?.partition_name || '');
      // return this.roleInfoObj.partition_name || '';
    },
    roleName() {
      return common.tool.Base64.decode(this.roleInfoObj?.role_name || '');
      // return this.roleInfoObj.role_name || '';
    },
  },
  methods: {
    // 确认领取奖励
    confirmHandler() {
      this.$emit('confirmReward', this.roleInfoObj);
    },
    // 更改其他角色
    changeBindHandler() {
      gameRoleSelect.showGameRoleSelect(this.gameCode, {})
        .then((roleInfo) => {
          console.log('select role=', roleInfo);
          // eslint-disable-next-line vue/no-mutating-props
          this.roleInfoObj = roleInfo;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ceiba-base-dialog-main {
  border-top: 0.1rem solid rgb(221, 184, 106);
}
.reward {
  width: 90%;
  height: 100%;
  border-bottom: 1px solid rgb(221, 184, 106, 0.2);
}

.title {
  font-size: 0.4rem;
}

.reward-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 80%;
}

.reward-role {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 100%;
  div {
    display: flex;
    justify-content: center;
    align-content: center;
  }
}


.reward-change-bind a {
  color: rgb(221, 184, 106);
  border-bottom: 1px solid rgb(221, 184, 106);
  font-size: 0.26rem;
}

.fotter-button {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 100%;
}

.confirm {
  display: flex;
  justify-content: center;
  align-content: center;
  font-size: 0.34rem;
  height: 0.6rem;
  margin: 0.1rem 0.3rem;
  min-width: 2rem;
  background-size: 100% 100%;
}

</style>
